import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import { api } from '../../helpers/api_helper';
import { API_ENDPOINTS } from '../../constants/apiEndPoints';
import Log from '../../Services/Log';
  

export const getBureau = createAsyncThunk('bureau/get', async (info, thunkAPI) => {
    try {
        const response = await api.get(API_ENDPOINTS.BUREAU.GET);
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response.data);
    }
});
